<template>
  <div class="user-rating-overlay" v-if="show" @click.self="close">
    <div class="user-rating-modal">
      <div class="rating-header">
        <h3>请为本次对话评分</h3>
        <button class="close-btn" @click="close">×</button>
      </div>
      
      <div class="rating-content">
        <!-- 对话摘要 -->
        <div class="conversation-summary" v-if="conversationInfo && conversationInfo.title!='' || this.conversationTitle!=''">
          <h4>对话摘要</h4>
          <div class="summary-content">
            <p><strong>主题：</strong>{{ this.conversationInfo.title===''?this.conversationTitle:this.conversationInfo.title }}</p>
          </div>
        </div>
        
        <!-- 星级评分 -->
        <div class="star-rating">
          <div class="stars">
            <span 
              v-for="star in 5" 
              :key="star"
              class="star"
              :class="{ 'active': star <= selectedRating, 'hover': star <= hoverRating }"
              @click="selectRating(star)"
              @mouseover="hoverRating = star"
              @mouseleave="hoverRating = 0"
            >
              ★
            </span>
          </div>
          <div class="rating-labels">
            <span v-for="(label, index) in ratingLabels" 
                  :key="index"
                  :class="{ 'active': index + 1 === selectedRating }">
              {{ label }}
            </span>
          </div>
        </div>
        
        <!-- 评价标签 -->
        <div class="rating-tags" v-if="selectedRating">
          <h4>选择评价标签（可选）</h4>
          <div class="tags-container">
            <span 
              v-for="tag in availableTags" 
              :key="tag.value"
              class="tag"
              :class="{ 'selected': selectedTags.includes(tag.value) }"
              @click="toggleTag(tag.value)"
            >
              {{ tag.label }}
            </span>
          </div>
        </div>
        
        <!-- 评价内容 -->
        <div class="rating-comment" v-if="selectedRating">
          <h4>详细评价（可选）</h4>
          <textarea 
            v-model="comment"
            placeholder="请分享您的使用体验和建议..."
            rows="4"
            maxlength="500"
          ></textarea>
          <div class="char-count">{{ comment.length }}/500</div>
        </div>
      </div>
      
      <div class="rating-footer">
        <button class="btn btn-secondary" @click="skip">跳过</button>
        <button 
          class="btn btn-primary" 
          @click="submit"
          :disabled="!selectedRating || isSubmitting"
        >
          <span v-if="isSubmitting">提交中...</span>
          <span v-else>提交评价</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { loadFeedbackData,submitFeedback } from '@/api/chat/feedback';

export default {
  name: 'UserRating',
  
  props: {
    show: {
      type: Boolean,
      default: false
    },
    conversationInfo: {
      type: Object,
      default: () => ({})
    },
    workspaceSlug:{
      type: String,
      default: ''
    },
  },
  
  data() {
    return {
      selectedRating: 0,

      hoverRating: 0,
      selectedTags: [],
      comment: '',
      conversationTitle:'',
      customerIntent:'',
      sentiment:'',
      isSubmitting: false,
      
      ratingLabels: ['非常差', '差', '一般', '好', '非常好'],
      
      availableTags: [
        { value: 'problem_solved', label: '解决了我的问题' },
        { value: 'reply_fast', label: '响应迅速' },
        { value: 'reply_accurate', label: '回答准确' },
        { value: 'reply_friendly', label: '态度友好' },
        { value: 'knowledge_insufficient', label: '掌握的信息不足' },
        { value: 'technability_insufficient', label: '处理问题能力不够' },
        { value: 'error_information_provided', label: '提供错误信息' },
        { value: 'not_friendly', label: '态度生硬' }
      ]
    };
  },
  
  watch: {
    show(newVal) {
      if (newVal) {
        this.resetForm();
      }
    }
  },
  mounted(){
    console.log(this.workspaceSlug)
    console.log(this.conversationInfo)
    loadFeedbackData(this.workspaceSlug, this.conversationInfo.threadSlug).then( response =>{
      console.log(response);
      if(response.data.code == 200){
      //this.conversationInfo = this.data.data;
        console.log(response.data.data);
        this.selectedRating = response.data.data.rating;

         this.selectedTags = response.data.data.tags;
         this.comment =  response.data.data.comment;
         this.conversationTitle=response.data.data.conversationTitle;
         this.customerIntent=response.data.data.customer_intent;
         this.sentiment=response.data.data.sentiment;

      }
    })
  },
  
  methods: {
    selectRating(rating) {
      this.selectedRating = rating;
    },
    
    toggleTag(tag) {
      const index = this.selectedTags.indexOf(tag);
      if (index === -1) {
        this.selectedTags.push(tag);
      } else {
        this.selectedTags.splice(index, 1);
      }
    },
    
    async submit() {
      if (!this.selectedRating) {
        this.$message.error('请先选择评分');
        return;
      }
      console.log("conversationInfo",this.conversationInfo);
      this.isSubmitting = true;
      
      try {
        const feedbackData = {
          conversationId: this.conversationInfo.conversationId,
       //   aiSeatId: this.conversationInfo.aiSeatId,
          threadSlug: this.conversationInfo.threadSlug,
          workspaceSlug: this.workspaceSlug,
          rating: this.selectedRating,
          comment: this.comment.trim(),
          tags: this.selectedTags,
          conversationTitle: this.conversationInfo.title==''?this.conversationTitle:this.conversationInfo.title,
          customer_intent: (this.conversationInfo.customerIntent==''|| this.conversationInfo.customerIntent==undefined)?this.customerIntent:this.conversationInfo.customerIntent,
          sentiment: this.conversationInfo.sentiment=='' ||this.conversationInfo.sentiment==undefined?this.sentiment:this.conversationInfo.sentiment
        };
      console.log("feedbackData",feedbackData);        
        await submitFeedback(feedbackData);
        
        this.$message.success('感谢您的评价！');
        this.$emit('submitted', feedbackData);
        this.close();
        
      } catch (error) {
        console.error('提交评价失败:', error);
        this.$message.error('提交评价失败，请稍后重试');
      } finally {
        this.isSubmitting = false;
      }
    },
    
    skip() {
      this.$emit('skipped');
      this.close();
    },
    
    close() {
      this.$emit('close');
    },
    
    resetForm() {
      this.selectedRating = 0;
      this.hoverRating = 0;
      this.selectedTags = [];
      this.comment = '';
      this.isSubmitting = false;
    }
  }
};
</script>

<style scoped>
.user-rating-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.3s ease;
}

.user-rating-modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.3s ease;
}

.rating-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e1e4e8;
}

.rating-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.close-btn:hover {
  background: #f5f5f5;
  color: #666;
}

.rating-content {
  padding: 24px;
}

.conversation-summary {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
}

.conversation-summary h4 {
  margin: 0 0 12px 0;
  color: #555;
  font-size: 14px;
  font-weight: 600;
}

.summary-content p {
  margin: 6px 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

.summary-content strong {
  color: #333;
}

.star-rating {
  text-align: center;
  margin-bottom: 24px;
}

.star-rating h4 {
  margin: 0 0 16px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.stars {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
}

.star {
  font-size: 36px;
  color: #e0e0e0;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
}

.star:hover {
  transform: scale(1.1);
}

.star.active {
  color: #ffc107;
}

.star.hover {
  color: #ffd54f;
}

.rating-labels {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #999;
}

.rating-labels span {
  flex: 1;
  text-align: center;
  transition: all 0.2s;
}

.rating-labels span.active {
  color: #ffc107;
  font-weight: 600;
}

.rating-tags h4 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 14px;
  font-weight: 600;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
}

.tag {
  padding: 6px 12px;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
}

.tag:hover {
  background: #e8e8e8;
}

.tag.selected {
  background: #e3f2fd;
  border-color: #2196f3;
  color: #1976d2;
}

.rating-comment h4 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 14px;
  font-weight: 600;
}

.rating-comment textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  box-sizing: border-box;
}

.rating-comment textarea:focus {
  outline: none;
  border-color: #2196f3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.1);
}

.char-count {
  text-align: right;
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.rating-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e1e4e8;
  background: #fafafa;
  border-radius: 0 0 12px 12px;
}

.btn {
  padding: 10px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary {
  background: #2196f3;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #1976d2;
}

.btn-primary:disabled {
  background: #bbdefb;
  cursor: not-allowed;
}

.btn-secondary {
  background: white;
  color: #666;
  border: 1px solid #e0e0e0;
}

.btn-secondary:hover {
  background: #f5f5f5;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 600px) {
  .user-rating-modal {
    width: 95%;
    margin: 10px;
  }
  
  .rating-content {
    padding: 16px;
  }
  
  .star {
    font-size: 32px;
  }
}
</style>